window.addEventListener('load', function() {
	let sticky  = document.getElementById("sticky_wrapper"); // 追従購入ボタン
	let scroll   = window.pageYOffset; // スクロール位置
	let target = document.getElementById("adsLeft").getBoundingClientRect().bottom + window.pageYOffset; // 左カラムのbottomの座標
	// ページロード時の処理
    if (scroll > target) { // 上部購入ボタンが見えなくなったら下部固定の購入ボタンを表示
        sticky.classList.add("show");
    }
	// スクロール時の処理
	window.addEventListener("scroll", function() {
        target = document.getElementById("adsLeft").getBoundingClientRect().bottom + window.pageYOffset;
        scroll = window.pageYOffset;
        if (scroll > target) { // 左カラムが見えなくなったら下部固定の購入ボタンを表示
            sticky.classList.add("show");
        } else { // 左カラムが見えているうちは下部固定の購入ボタンを非表示
            sticky.classList.remove("show");
        }
	});
});